import React from 'react';

import { Label } from 'core/components/label';
import useStyles from './hardware-mfa.styles';

function RegisteringMFA() {
  const styles = useStyles();

  return (
    <Label type="infoInnerTitle" className={styles.content}>
      Please wait while we set up your device. Registration should just take a few moments.
    </Label>
  );
}

export default RegisteringMFA;
